/**
 * @generated SignedSource<<42ef006d59fcb75ac7bdbc11c7f8ec80>>
 * @relayHash b166cb02008e1ced909e66efb1618724
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f20db408527e12b3b82266fb8dbd13b035a569d68a64e5fcf9e00d7df264ab4

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentReopenCommentMutation$variables = {
  cloudId: string;
  commentId: string;
};
export type CommentReopenCommentMutation$data = {
  readonly confluence_reopenComment: {
    readonly commentResolutionStates: {
      readonly commentId: string;
      readonly status: boolean | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly __typename: "ReopenCommentsMutationErrorExtension";
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type CommentReopenCommentMutation = {
  response: CommentReopenCommentMutation$data;
  variables: CommentReopenCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "commentId",
    "variableName": "commentId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "ConfluenceCommentResolutionState",
  "kind": "LinkedField",
  "name": "commentResolutionStates",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "commentId"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "errorType"
    },
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ],
  "type": "ReopenCommentsMutationErrorExtension"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CommentReopenCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ConfluenceReopenCommentPayload",
        "kind": "LinkedField",
        "name": "confluence_reopenComment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentReopenCommentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "ConfluenceReopenCommentPayload",
        "kind": "LinkedField",
        "name": "confluence_reopenComment",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b166cb02008e1ced909e66efb1618724",
    "id": "7f20db408527e12b3b82266fb8dbd13b035a569d68a64e5fcf9e00d7df264ab4",
    "metadata": {},
    "name": "CommentReopenCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentReopenCommentMutation($commentId:ID!,$cloudId:ID!){confluence_reopenComment(commentId:$commentId,cloudId:$cloudId){success,commentResolutionStates{commentId,status},errors{message,extensions{...on ReopenCommentsMutationErrorExtension{errorType,statusCode},__typename,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "119c695b9232d3c254c219ff60606f0d";

export default node;
